import React, { FunctionComponent as FC, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'; // To call Action Creators
import { bindActionCreators } from 'redux';
import { actionCreators } from '../../../../../state';
import { State } from '../../../../../state';
import _ from 'lodash';
import * as d3 from  "d3";
import './index.scss';

import { MainViewTypes } from '../../../../../types/data';

interface CitationFlowProps {
  linkPathList: MainViewTypes.CitationFlowPathUnit[];
  nodePositionList: MainViewTypes.NodePosition[];
  leafNodeEdgeData: any[];
}

const CitationFlow: FC<CitationFlowProps> = (props) => {

  const {
    linkPathList, nodePositionList, leafNodeEdgeData
  } = props

  // console.log('\n\n========== Component: CitationFlow (started!) ============')

  // ui reducer
  const predictionSearchResult: MainViewTypes.PredictionSearchResult = useSelector((state: State) => state.dataReducer?.predictionSearchResult) as MainViewTypes.PredictionSearchResult
  const isShowHistoricalFlow: boolean = useSelector((state: State) => state.uiReducer?.isShowHistoricalFlow) as boolean
  const isShowPredictionFlow: boolean = useSelector((state: State) => state.uiReducer?.isShowPredictionFlow) as boolean
  const topKCitationFlow: number = useSelector((state: State) => state.uiReducer?.topKCitationFlow) as number
  const highlghtedGrantFieldID: string = useSelector((state: State) => state.dataReducer?.highlghtedGrantFieldNode.grantFieldID) as string
  const highlightedImpactFieldNode: MainViewTypes.HighlightedImpactFieldNode = useSelector((state: State) => state.dataReducer?.highlightedImpactFieldNode) as MainViewTypes.HighlightedImpactFieldNode

  // // debug
  // console.log('isShowHistoricalFlow: ', isShowHistoricalFlow)
  // console.log('isShowPredictionFlow: ', isShowPredictionFlow)
  // console.log('highlghtedGrantFieldID: ', highlghtedGrantFieldID)
  console.log('==> CitationFlow() > highlightedImpactFieldNode: ', highlightedImpactFieldNode)


  // set link scale
  const linkScale = d3.scalePow()  // scaleLinear()
  // @ts-ignore
  .domain(d3.extent(leafNodeEdgeData, d => d.num_citation))
  .range([1.5, 10])  // [2, 20]
  .exponent(1)
  // const linkScale = d3.scaleLinear()  // scaleLinear()
  // // @ts-ignore
  // .domain(d3.extent(leafNodeEdgeData, d => d.num_citation))
  // .range([2, 5])



  let nodeElementList: JSX.Element[] = []
  let linkElementList: JSX.Element[] = []
  // //////////////////  2-2 & 2-3: move from the parent component (i.e., EntityFieldLevelCitationFlow), avoid highlighting to re-render/re-run force-bundle (start)  ///////////////
  // 2-2. draw link element
  // // input
  // console.log('linkPathList: ', linkPathList)
  // console.log('isShowHistoricalFlow: ', isShowHistoricalFlow)
  // console.log('isShowPredictionFlow: ', isShowPredictionFlow)
  // console.log('nodePositionList: ', nodePositionList)
  // console.log('highlghtedGrantFieldID: ', highlghtedGrantFieldID)
  // console.log('predictionSearchResult: ', predictionSearchResult)
  // console.log('isShowHistoricalFlow: ', isShowHistoricalFlow)
  // console.log('isShowPredictionFlow: ', isShowPredictionFlow)
  // console.log('highlghtedGrantFieldID: ', highlghtedGrantFieldID)
  // console.log('highlightedImpactFieldNode: ', highlightedImpactFieldNode)

  let highlightedGrantNode_linkPathList = [] // historical flow, start from grant_field node
  let highlightedImpactFieldNode_linkPathList = [] // prediction flow, start from impact_field node


  const getTopKLinks = (highlightedNode_linkPathList: any[]) => {
    // Group by "linkType"
    const grouped = highlightedNode_linkPathList.reduce((acc: any, cur: any) => {
      acc[cur.linkType] = acc[cur.linkType] || [];
      acc[cur.linkType].push(cur);
      return acc;
    }, {});
    const topK = Object.values(grouped).map((group: any) =>
      group.sort((a: any, b: any) => b.num_citation - a.num_citation).slice(0, topKCitationFlow)
    );
    // Concat all top K elements together in a new list
    const topKLinks = [].concat(...topK);
    // console.log("topKLinks: ", topKLinks)
    // console.log('linkPathList: ', linkPathList)
    return topKLinks
  }
  if (isShowHistoricalFlow) {
    if ((highlghtedGrantFieldID !== '') && (linkPathList.length > 0)) {
      // scenario 1: start from a grant_field node, highlight its links to imapct_field nodes
      // 1. filter this grant node's all links
      highlightedGrantNode_linkPathList = linkPathList.filter(linkData => (linkData.source === highlghtedGrantFieldID))

      // 2. get topK link by each impact entity type
      const topKLinks = getTopKLinks(highlightedGrantNode_linkPathList)
      // // Group by "linkType"
      // const grouped = highlightedGrantNode_linkPathList.reduce((acc: any, cur: any) => {
      //   acc[cur.linkType] = acc[cur.linkType] || [];
      //   acc[cur.linkType].push(cur);
      //   return acc;
      // }, {});
      // const topK = Object.values(grouped).map((group: any) =>
      //   group.sort((a: any, b: any) => b.num_citation - a.num_citation).slice(0, topKCitationFlow)
      // );
      // // Concat all top K elements together in a new list
      // const topKLinks = [].concat(...topK);
      // // console.log("topKLinks: ", topKLinks)
      // // console.log('linkPathList: ', linkPathList)

      // 3. draw path
      linkElementList = linkPathList.map((linkData: any) => {
        const isHighlight = _.some(topKLinks, linkData)
        return (
          <path id={`citation-link-${linkData.source}-${linkData.target}`}
                className="citation-link citation-link-historical"
                d={linkData.path}
                // stroke="url(#fadeStroke)"
                stroke="#C3D4D5"
                // stroke="#5d8485"
                // stroke="lightgrey" strokeWidth={linkScale(linkData.num_citation)}
                strokeWidth={linkScale(linkData.num_citation)}
                fill="none"
                opacity={ (isHighlight) ? 0.7 : 0 }  // 0.2 : 0
          />
        )
      })
    } else if ((highlightedImpactFieldNode.impactFieldID !== '') && (linkPathList.length > 0)) {
      // scenario 2: start from a impact_field node, highlight its links to grant_field nodes
      // 1. filter this impact node's all links
      highlightedImpactFieldNode_linkPathList = linkPathList.filter(linkData => (linkData.target === highlightedImpactFieldNode.impactFieldID))

      // 2. get topK link by each impact entity type
      const topKLinks = getTopKLinks(highlightedImpactFieldNode_linkPathList)

      // 3. draw path
      linkElementList = linkPathList.map((linkData: any) => {
        const isHighlight = _.some(topKLinks, linkData)
        return (
          <path id={`citation-link-${linkData.source}-${linkData.target}`}
                className="citation-link citation-link-historical"
                d={linkData.path}
                // stroke="url(#fadeStroke)"
                stroke="#C3D4D5"
                // stroke="#5d8485"
                // stroke="lightgrey" strokeWidth={linkScale(linkData.num_citation)}
                strokeWidth={linkScale(linkData.num_citation)}
                fill="none"
                opacity={ (isHighlight) ? 0.5 : 0 } // 0.2 : 0
          />
        )
      })
    }
  } else if (isShowPredictionFlow) {
    if ((highlightedImpactFieldNode.impactFieldID !== '') && (linkPathList.length > 0)) {
    // console.log('predictionSearchResult.fieldIDList: ', predictionSearchResult.fieldIDList)
    // console.log('linkPathList: ', linkPathList)
    // 1. filter out all links, based on selected impact entity field node
    highlightedImpactFieldNode_linkPathList = linkPathList.filter(linkData => predictionSearchResult.fieldIDList.includes(linkData.target))

    // 2. filter topK links
    const topKLinks = _.take(_.orderBy(highlightedImpactFieldNode_linkPathList, ['num_citation'], ['desc']), topKCitationFlow)
    // console.log('topKLinks: ', topKLinks)

    // 3. draw path
    // note: prediction flow的width不需要scale，因为没有num_citation这个维度；只有grant_field size可以表示grant的多少
    linkElementList = linkPathList.map((linkData: any) => {
      const isHighlight = _.some(topKLinks, linkData)
      // console.log('isHighlight: ', isHighlight)
      return <path
                id={`citation-link-${linkData.source}-${linkData.target}`}
                d={linkData.path}
                className="citation-link citation-link-predicted"
                stroke="#AE7BAC"
                strokeWidth={1.5}
                strokeDasharray={"6 12"}
                fill="none"
                opacity={ (isHighlight) ? 0.95 : 0 }  // 0.8 : 0
                />
    })
    // linkElementList = topKLinks.map((linkData: any) => {
    //   return <path
    //             id={`citation-link-${linkData.source}-${linkData.target}`}
    //             d={linkData.path}
    //             className="citation-link-predicted"
    //             stroke="#AE7BAC"
    //             strokeWidth={3}
    //             strokeDasharray={"6 12"}
    //             // strokeWidth={linkScale(linkData.num_citation)}
    //             fill="none"
    //             // opacity={ (isHighlight) ? 0.2 : 0 }
    //             opacity={0.8}
    //             />
    // })
    }
  }




  // 2-3. draw node element (only for debug)
  nodeElementList = nodePositionList.map((node) => (
    <circle cx={node.x} cy={node.y} r={node.r} fill='red' opacity={0.5} />
  ))
  // //////////////////  2-2 & 2-3: move to the child component, avoid highlighting to re-render/re-run force-bundle (end)  ///////////////


  // console.log('linkElementList: ', linkElementList)


  // console.log('\n\n========== Component: CitationFlow (end!) ============')

  return (
    <g className='citation-flow-g'>
      {linkElementList}
      {/* {nodeElementList} */}
    </g>
  )
}

export default CitationFlow;